<template>
  <section>
    <v-layout column align-center>
      <v-flex>
      <e-upload
        :extensions="['jpeg', 'jpg', 'png', 'tiff', 'gif', 'bmp']"
        :multiple="true"
        :directUpload="false"
        @filePicked="onFilePicked"
        :disabled="!isWriteAvailable"
        padding="pa-0"
        class="upload-button"
        :btnAppearance="btnAppearance"
        :btnText="uploadButtonText"
        :hideIcon="uploadButtonHideIcon"
        :color="uploadButtonColor"
      />
      </v-flex>
    </v-layout>

    <v-dialog
      persistent
      v-model="isModalOpen"
      class="media-modal"
    >
      <v-card color="grey lighten-1">
        <v-layout row wrap justify-center v-if="isMultipleUpload">
          <v-flex md12 lg8 justify-center>
            <v-layout row wrap justify-center align-center class="py-2">
              <v-flex sm6 md3 lg4 align-center>
                <v-subheader>Multiple images will be uploaded with this sizes:</v-subheader>
              </v-flex>
              <v-flex sm2 md3 lg2>
                <v-checkbox
                  label="Small"
                  value="small"
                  color="grey darken-3"
                  hide-details
                  v-model="commonSizes"
                />
              </v-flex>
              <v-flex sm2 md3 lg2>
                <v-checkbox
                  label="Medium"
                  value="medium"
                  color="grey darken-3"
                  hide-details
                  v-model="commonSizes"
                />
              </v-flex>
              <v-flex sm2 md3 lg2>
                <v-checkbox
                  label="Large"
                  value="large"
                  color="grey darken-3"
                  hide-details
                  v-model="commonSizes"
                />
              </v-flex>
              <v-flex sm12 md4 lg2>
                <v-btn raised color="success" @click="uploadAllImagesRequest">Upload all images</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>

      <v-layout row wrap>
        <v-flex
          v-for="(file, i) in files"
          :key="file.id"
          class="mx-auto"
        >
          <v-card class="my-1">

            <v-toolbar color="grey lighten-1" flat dense>
              <v-toolbar-title>{{file.name}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="removeItem(file.id)">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>

            <div class="crop-wrapper">
              <vue-cropper
                ref="cropper"
                :background="false"
                :auto-crop="!isSvg"
                :auto-crop-area="1"
                :responsive="true"
                drag-mode="crop"
                :guides="true"
                :view-mode="2"
                :min-container-height="300"
                :containerStyle="containerStyle"
                :src="file.url"
                :ready="cropperReady"
              />
            </div>

            <div v-if="!isSvg">
              <v-card-actions>
                <v-layout row>
                  <v-flex d-flex justify-space-between>
                    <div>
                      <v-btn small @click="rotateLeft(file.id)"><v-icon>undo</v-icon></v-btn>
                      <v-btn small @click="rotateRight(file.id)"><v-icon>redo</v-icon></v-btn>
                    </div>
                    <v-btn color="success" style="max-width: 50px;" outline @click="cropImage(file.id)">Crop</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </div>

            <v-card-title>
              <v-container column fluid grid-list-md justify-center align-center>
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-layout row wrap justify-center v-if="!isSvg && !isMultipleUpload">
                    <v-flex xs12>
                      Upload single image with sizes
                    </v-flex>
                    <v-flex md4 lg3 offset-lg1>
                      <v-checkbox
                        label="Small"
                        value="small"
                        color="grey darken-3"
                        hide-details
                        v-model="galleriesData[i].sizes"
                      />
                    </v-flex>
                    <v-flex md4 lg3>
                      <v-checkbox
                        label="Medium"
                        value="medium"
                        color="grey darken-3"
                        hide-details
                        v-model="galleriesData[i].sizes"
                      />
                    </v-flex>
                    <v-flex md4 lg3>
                      <v-checkbox
                        label="Large"
                        value="large"
                        color="grey darken-3"
                        hide-details
                        v-model="galleriesData[i].sizes"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-text-field
                        label="Title"
                        color="grey darken-3"
                        hide-details
                        v-model="galleriesData[i].title"
                      />
                      <!--:rules="titleRules"-->
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-text-field
                        label="Alt"
                        color="grey darken-3"
                        hide-details
                        v-model="galleriesData[i].alt"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-select
                        label="Categories"
                        chips
                        tags
                        append-icon=""
                        hide-details
                        v-model="galleriesData[i].categories"
                      >
                        <template slot="selection" slot-scope="category">
                          <v-chip
                            close
                            @click="filterGalleriesByCategory(category.item)"
                            @input="removeItemCategory(category.item)"
                            :selected="category.selected"
                          >
                            {{category.item}}
                          </v-chip>
                        </template>
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-form>

                <v-card-actions v-if="!isMultipleUpload">
                  <v-flex align-center justify-center>
                    <v-btn raised color="success" @click="uploadSingleImage(file.id)">Upload this image</v-btn>
                  </v-flex>
                </v-card-actions>

              </v-container>
            </v-card-title>

          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>

  </section>
</template>

<script>
import {path, map, find, propEq, not, findIndex, lensPath, set, append, prop, groupBy, mergeDeepLeft, omit, filter, differenceWith, equals, any, view} from 'ramda'
import uuidv4 from 'uuid/v4'
import { mapActions } from 'vuex'
import VueCropper from 'vue-cropperjs'
import mixins from '@/utils/mixins'

import EUpload from '@/components/shared/Upload'

  export default {
    name: "UploadSection",
    mixins: [mixins.isWriteAvailable],
    components: { VueCropper, EUpload },
    props: {
      btnAppearance: {
        type: Object,
        default: () => {
          return {
            text: 'Upload File',
            color: '',
            raised: true,
            hideIcon: false
          }
        }
      },
      uploadButtonText: {
        type: String,
        default: 'Upload file'
      },
      uploadButtonColor: {
        type: String,
        default: ''
      },
      uploadButtonHideIcon: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        files: [],
        galleriesData: [],
        showModal: false,
        error: "",
        commonSizes: [],
        valid: true,
        // titleRules: [(v) => !!v ],
        containerStyle: {height: '300px'},
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'general_settings:write',
        isModalOpen: false,
      }
    },
    computed: {
      isSvg () {
        return this.files[0].type === 'image/svg+xml'
      },
      isMultipleUpload () {
        return this.files.length > 1
      }
    },
    watch: {
      isModalOpen: {
        handler (newVal) {
          // clear modal data if closed
          if (!newVal) {
            this.files = []
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'uploadImage',
        'postImageDetails',
        'showResultErrorMessage',
        'postAllImagesDetails'
      ]),
      cropperReady () {
        if (this.isSvg) {
          this.$refs.cropper[0].disable()
        }
      },
      onFilePicked (files) {
        map(this.beforeUpload, files)
        this.isModalOpen = true
      },
      beforeUpload (file) {
        let reader = new FileReader()
        let id = uuidv4()
        reader.onloadend = () => {
          let result = {
            id,
            name: file.name,
            size: file.size,
            url: reader.result,
            type: file.type,
            file
          }
          this.files = [...this.files, result]
          let obj = {id: result.id, title: '', alt: '', categories: [], sizes: []}
          this.galleriesData = [...this.galleriesData, obj]
        }
        reader.readAsDataURL(file)
      },
      removeItem(id){
        let fn = item => not(equals(id, item.id))
        this.files = filter(fn, this.files)
        this.galleriesData = filter(fn, this.galleriesData)
        if(!this.files.length) {
          this.isModalOpen = false
        }
      },
      async uploadSingleImage (id) {
        const index = findIndex(propEq('id', id))(this.files)
        if( not(this.$refs.form[index].validate()) ){
          this.showResultErrorMessage('Check images data! Some titles are missing')
          return
        }

        const currentGalleriesData = find(propEq('id', id))(this.galleriesData)
        const sizes = path(['sizes'], currentGalleriesData)
        const alt = path(['alt'], currentGalleriesData)
        const title = path(['title'], currentGalleriesData)
        const categories = path(['categories'], currentGalleriesData)
        const currentFile = find(propEq('id', id))(this.files)
        const blob = path(['file'], currentFile)
        const transforms = this.createTransformObj(sizes)
        let formData = new window.FormData()
        formData.append('file', blob, id)
        formData.append('Configuration', JSON.stringify(transforms))
        const response = await this.uploadImage(formData)

        const imagesUrls = path([0, 'imagesUrls'], response)
        let galleries = {
          galleries: [
            {
              imagesUrls,
              alt,
              title,
              categories
            }
          ]
        }
        await this.postImageDetails(galleries)
        this.$emit('lastUploadedPhotos', galleries.galleries)
        this.$bus.$emit('getGalleries')
        this.removeItem(id)
        this.isModalOpen = false
      },
      async uploadAllImagesRequest () {
        let validateArr = map(form => form.validate(), this.$refs.form)
        if(any(equals(false))(validateArr)) {
          this.showResultErrorMessage('Check images data! Some titles are missing')
          return
        }

        const formData = new FormData()
        const transforms = this.createTransformObj(this.commonSizes)
        formData.append('Configuration', JSON.stringify(transforms))

        let galleryItemsToSend = this.files.reduce((acc, file) => {
          const currentGalleriesData = find(propEq('id', file.id))(this.galleriesData)
          const alt = path(['alt'], currentGalleriesData)
          const title = path(['title'], currentGalleriesData)
          const categories = path(['categories'], currentGalleriesData)
          const blob = prop(['file'], file)
          const data = {id: file.id, file: blob, alt, title, categories}
          acc = append(data, acc)
          formData.append('file', blob, file.id)
          return acc
        }, [])
        const response = await this.uploadImage(formData)

        let galleriesGroupedById = groupBy(prop('id'), galleryItemsToSend)
        let galleriesToOmit = map(galleryUrls => mergeDeepLeft(galleryUrls, galleriesGroupedById[galleryUrls.id][0]), response)
        let galleries = map(item => omit(['id', 'file'], item), galleriesToOmit)
        await this.postAllImagesDetails({ galleries }, galleryItemsToSend)
        this.$emit('lastUploadedPhotos', galleries)
        this.$bus.$emit('getGalleries')
        if (galleriesToOmit.length > 0) {
          let cmp = (x, y) => x.id === y.id
          this.files = differenceWith(cmp, this.files, galleriesToOmit)
          this.galleriesData = differenceWith(cmp, this.galleriesData, galleriesToOmit)
        }
        this.isModalOpen = false
      },
      createTransformObj (sizes = []) {
        let Transforms = []
        sizes.forEach(size => {
          let width
          if (size === 'small') {
            width = 360
          } else if (size === 'medium') {
            width = 720
          } else if (size === 'large') {
            width = 1080
          }
          let item = { TransformName: size, Width: width }
          Transforms.push(item)
        })
        return { Transforms }
      },
      cropImage (id) {
        let index = findIndex(propEq('id', id))(this.files)
        let canvas = this.$refs.cropper[index].getCroppedCanvas()
        let urlPath = lensPath([index, 'url'])
        let blobPath = lensPath([index, 'file'])
        let sizePath = lensPath([index, 'size'])
        let type = view(lensPath([index, 'type']), this.files)

        let newUrl = canvas.toDataURL(type)
        this.$refs.cropper[index].replace(newUrl)
        this.files = set(urlPath, newUrl, this.files)
        canvas.toBlob(data => {
          this.files = set(blobPath, data, this.files)
          this.files = set(sizePath, data.size, this.files)
        })
      },
      rotateLeft (id) {
        let index = findIndex(propEq('id', id))(this.files)
        this.$refs.cropper[index].rotate(90);
      },
      rotateRight (id) {
        let index = findIndex(propEq('id', id))(this.files)
        this.$refs.cropper[index].rotate(-90);
      }
    }
  }
</script>

<style>
  input[type=file] {
    position: absolute;
    left: -99999px;
  }

  .crop-wrapper {
    display: flex;
    justify-content: center;
    height: 300px;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/AUploadSection/index.vue